import React, { lazy, Suspense, useEffect } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';
import { initMetaPixel } from './utils/metaPixel';

// Everything below the hero is code-split so it doesn't compete with the
// hero/LCP for the browser's main thread on first paint.
const TaglineBanner = lazy(() => import('./components/sections/TaglineBanner').then(mod => ({
  default: mod.TaglineBanner
})));
const Problems = lazy(() => import('./components/sections/Problems').then(mod => ({
  default: mod.Problems
})));
const Solution = lazy(() => import('./components/sections/Solution').then(mod => ({
  default: mod.Solution
})));
const Volumes = lazy(() => import('./components/sections/Volumes').then(mod => ({
  default: mod.Volumes
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(mod => ({
  default: mod.Bonuses
})));
const ValueTable = lazy(() => import('./components/sections/ValueTable').then(mod => ({
  default: mod.ValueTable
})));
const PriceReveal = lazy(() => import('./components/sections/PriceReveal').then(mod => ({
  default: mod.PriceReveal
})));
const WhyItWorks = lazy(() => import('./components/sections/WhyItWorks').then(mod => ({
  default: mod.WhyItWorks
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const HowItWorks = lazy(() => import('./components/sections/HowItWorks').then(mod => ({
  default: mod.HowItWorks
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const Objections = lazy(() => import('./components/sections/Objections').then(mod => ({
  default: mod.Objections
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="d3mn9jzh3bod">
      <div className="w-full min-h-full bg-cream font-body text-ink" data-id="element-1" data-mp="d2l7513lnyzs">
        <main data-id="element-2" data-mp="86w3alkjrvxo">
          <Hero data-id="element-3" data-mp="86cld4uwd7jn" />
          <Suspense fallback={null} data-id="element-4" data-mp="83qi3hf1he78">
            <TaglineBanner data-id="element-5" data-mp="3gklb8561bk84" />
            <Problems data-id="element-6" data-mp="3glwbhv09u9uh" />
            <Solution data-id="element-7" data-mp="3gja2rs1n9oao" />
            <Volumes data-id="element-8" data-mp="3bmjsxmgfnoxp" />
            <Bonuses data-id="element-9" data-mp="3bn314bga6yyj" />
            <ValueTable data-id="element-10" data-mp="3bnutzeihuil4" />
            <PriceReveal data-id="element-11" data-mp="3bk736n4foaa3" />
            <WhyItWorks data-id="element-12" data-mp="3qaxu7sy7b5c5" />
            <Testimonials data-id="element-13" data-mp="3qc95sexw1hdt" />
            <HowItWorks data-id="element-14" data-mp="3qcim1at4sa6b" />
            <Guarantee data-id="element-15" data-mp="3lkheg26wr7mm" />
            <FAQ data-id="element-16" data-mp="3ljxukfxp695y" />
            <Objections data-id="element-17" data-mp="3ljg09ouli50o" />
            <FinalCTA data-id="element-18" data-mp="3lj69w05n1vug" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="2xu3kg64riype">
          <Footer data-id="element-20" data-mp="2xtbvvf9l218m" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="2svtqtzyos65w" />
      </div>
    </LazyMotion>;
}